var map = {
	"./app_en.jpg": 107,
	"./app_ita.jpg": 108,
	"./get_app_download.png": 202,
	"./natale.png": 203
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 201;


//////////////////
// WEBPACK FOOTER
// ./src/include/images ^\.\/.*$
// module id = 201
// module chunks = 0